import React from "react";
import { Box, Grid } from "@material-ui/core";
import { TextAreaContainer } from "modus/components/form/textarea-container/TextAreaContainer";

interface CallbackLogoutFieldProps {
  counter: number | undefined;
  label: string | JSX.Element;
  placeholder: string;
  value: string | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  setError: (error: boolean) => void;
  customError: { valid: boolean; message: string };
  required?: boolean;
  disabled?: boolean;
}

const CallbackLogoutField: React.FC<CallbackLogoutFieldProps> = ({
  counter,
  label,
  placeholder,
  value,
  onChange,
  name,
  setError,
  customError,
  required = false,
  disabled = false,
}) => {
  return (
    <>
      <Grid
        container
        spacing={0}
        style={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box style={{ textAlign: "left", flexGrow: 1 }}>
          {label}
          {required && <span className="required">*</span>}
        </Box>
        <Box  style={{ textAlign: "right" , flexGrow: 1}}>
          {counter} / 250
        </Box>
      </Grid>
      <TextAreaContainer
        placeholder={placeholder}
        value={value}
        name={name}
        setError={setError}
        onChange={onChange}
        disabled={disabled}
        validate={{
          required: required,
          custom: customError,
        }}
      ></TextAreaContainer>
    </>
  );
};

export default CallbackLogoutField;
